<template>
  <div class="contact-info-page" dir="rtl">
    <div class="content">
      <div class="profile-block">
        <button type="button" class="avatar-btn" @click="dialog2 = true" aria-label="گالری تصاویر">
          <img
            :src="user_info.ThumbPath || '/img/default-avatar.png'"
            :alt="displayName"
            class="avatar-img"
          />
          <span class="avatar-badge" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </span>
        </button>

        <h1 class="profile-name">{{ displayName }}</h1>
        <p class="profile-code" v-if="displayCode">{{ displayCode }}</p>

        <button type="button" class="message-btn" @click="goToDetail()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span>ارسال پیام</span>
        </button>
      </div>

      <div class="info-card">
        <div class="info-row">
          <div class="info-icon info-icon--blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="9" r="3" stroke="#007AFF" stroke-width="1.5"/>
              <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="info-text">
            <span class="info-label">{{ $t('userId') }}</span>
            <span class="info-value">{{ displayCode || '—' }}</span>
          </div>
        </div>

        <div class="info-row info-row--border">
          <div class="info-icon info-icon--indigo">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          <div class="info-text">
            <span class="info-label">{{ $t('notification') }}</span>
            <span class="info-hint">فعال / غیرفعال کردن اعلان‌ها</span>
          </div>
          <label class="tw-switch" :class="{ 'is-on': switch1 }">
            <input type="checkbox" v-model="switch1" class="tw-switch-input" />
            <span class="tw-switch-track" aria-hidden="true">
              <span class="tw-switch-knob"></span>
            </span>
          </label>
        </div>
      </div>
    </div>

    <div v-if="dialog2" class="fixed inset-0 z-999">
      <div class="absolute inset-0 bg-black bg-opacity-60" @click="dialog2 = false"></div>
      <div class="relative z-10 flex h-full w-full bg-white">
        <div class="gallery-close">
          <button type="button" @click="dialog2 = false" aria-label="بستن">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6L18 18M18 6L6 18" stroke="#111827" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="flex-1 content-center overflow-hidden p-5">
          <div v-if="!photos || photos.length === 0" class="h-full flex items-center justify-center text-gray-400 text-sm">
            تصویری یافت نشد
          </div>
          <VueSlickCarousel v-else :arrows="true" :dots="false" class="gallery-carousel">
            <div v-for="(item, index) in photos" :key="index" class="gallery-item">
              <img :src="item.ImageUrl" :alt="'تصویر ' + (index + 1)" class="gallery-img" />
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  export default {
    data () {
      return {
        user_info: '',
        items: '',
        switch1: true,
        dialog2: false,
        photos: '',
        UserId: '',
        group_flag: false,
        silent_list: [],
      }
    },
    components: { VueSlickCarousel },
    computed: {
      displayName () {
        if (!this.user_info) return ''
        return this.group_flag ? (this.user_info.GroupName || '') : (this.user_info.Name || '')
      },
      displayCode () {
        if (!this.user_info) return ''
        return this.group_flag ? (this.user_info.GroupCode || '') : (this.user_info.UserCode || '')
      },
    },
    watch: {
      switch1: function (val) {
        if (val == false) {
          this.add_silent('add')
        }
      }
    },
    methods: {
      add_silent (txt) {
        if (txt == 'add') {
          console.log('an')
          var thing = []
          if (localStorage.getItem('silent3') == null) {
            var thing = []
            thing.push(this.items.UserOrGroupId)
            localStorage.setItem('silent3', JSON.stringify(thing))
          } else {
            thing = localStorage.getItem('silent3')
            thing = JSON.parse(thing)
            var filter = false
            for (var i = 0; i < thing.length; i++) {
              if (thing[i] == this.items.UserOrGroupId) {
                filter = true
              }
            }
            if (filter == false) {
              thing.push(this.items.UserOrGroupId)
              localStorage.setItem('silent3', JSON.stringify(thing))
            }
          }
        }
      },
      goToDetail (item) {
        const last_chat_detail = {
          RecType: this.items.RecType,
          UserOrGroupId: this.items.UserOrGroupId,
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversation'), params: {} })
      },
      GetUserImages () {
        const send_data = {
          UserId: this.items.UserOrGroupId,
          RecType: this.items.RecType,
        }
        var self = this
        this.axios.post('/GetUserImages', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('user info', response.data.imgs)
              self.photos = response.data.imgs
            }
          }).catch(e => {

          })
      },
      getGroupInfo () {
        console.log('get group info')
        const send_data = {
          UserId: this.UserId,
          GroupId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetGroupInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

          })
      },
      getUserInfo () {
        const send_data = {
          UserId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetUserInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('user info', response.data.userInfo)
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

          })
      },
    },
    mounted () {
      var user_data = JSON.parse(localStorage.getItem('profile'))

      this.UserId = user_data.UserId
      this.items = JSON.parse(localStorage.getItem('lastChat'))
      if (this.items.RecType == 0) {
        this.getUserInfo()
        this.group_flag = false
      } else {
        this.getGroupInfo()
        this.group_flag = true
      }
      this.GetUserImages()
    }
  }
</script>

<style scoped>
.contact-info-page {
  min-height: 100vh;
  background: #f9fafb;
  padding-bottom: 88px;
}

.content {
  max-width: 32rem;
  margin: 0 auto;
  padding: 24px 16px;
}

.profile-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0 24px;
}

.avatar-btn {
  position: relative;
  width: 112px;
  height: 112px;
  border-radius: 9999px;
  overflow: visible;
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 0;
  cursor: pointer;
}

.avatar-img {
  width: 112px;
  height: 112px;
  border-radius: 9999px;
  object-fit: cover;
  display: block;
}

.avatar-badge {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: #1c39bb;
  color: #fff;
  border: 3px solid #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.profile-name {
  margin-top: 14px;
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
}

.profile-code {
  margin-top: 4px;
  font-size: 0.875rem;
  color: #6b7280;
}

.message-btn {
  margin-top: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 180px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
}

.message-btn:hover {
  filter: brightness(0.96);
}

.info-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

.info-row--border {
  border-top: 1px solid #f3f4f6;
}

.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon--blue {
  background: #dbeafe;
}

.info-icon--indigo {
  background: #e0e7ff;
}

.info-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  text-align: right;
}

.info-label {
  font-size: 0.8rem;
  color: #6b7280;
}

.info-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
  margin-top: 2px;
}

.info-hint {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 2px;
}

.tw-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  width: 44px;
  height: 24px;
}

.tw-switch-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.tw-switch-track {
  width: 44px;
  height: 24px;
  min-width: 44px;
  min-height: 24px;
  border-radius: 9999px;
  background-color: #d1d5db;
  position: relative;
  display: block;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  pointer-events: none;
}

.tw-switch-knob {
  position: absolute;
  top: 2px;
  right: 2px;
  left: auto;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: right 0.2s ease, left 0.2s ease;
  box-sizing: border-box;
  display: block;
}

.tw-switch.is-on .tw-switch-track,
.tw-switch-input:checked + .tw-switch-track {
  background-color: #1c39bb;
}

.tw-switch.is-on .tw-switch-knob,
.tw-switch-input:checked + .tw-switch-track .tw-switch-knob {
  right: auto;
  left: 2px;
}

.tw-switch-input:focus-visible + .tw-switch-track {
  box-shadow: 0 0 0 3px rgba(28, 57, 187, 0.25);
}

.gallery-close {
  position: absolute;
  top: 5rem;
  right: 1.25rem;
  z-index: 20;
  border: 1px solid #e5e7eb;
  border-radius: 9999px;
  padding: 6px;
  background: #fff;
}

.gallery-carousel {
  width: 100%;
}

.gallery-item {
  padding: 0 8px;
  text-align: center;
}

.gallery-img {
  max-height: 70vh;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  border-radius: 0.5rem;
  object-fit: contain;
}
</style>
